module.exports = __webpack_public_path__ + "static/fonts/SanFranciscoDisplayRegular.747b751.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/SanFranciscoDisplayRegular.ttf
// module id = byJK
// module chunks = 1